import { gql } from '@apollo/client';

export const DELETE_WORK_SITUATION = gql`
    mutation DeleteWorkSituation($id: ID!) {
        deleteWorkSituation(id: $id) {
            id
        }
    }
`;
